interface IntakeFieldRowProps {
  label: string;
  value: React.ReactNode;
}

export function IntakeFieldRow({ label, value }: IntakeFieldRowProps) {
  if (value === null || value === undefined || value === '') return null;
  
  return (
    <div className="flex justify-between py-1.5 border-b border-border/50 last:border-0">
      <span className="text-muted-foreground">{label}</span>
      <span className="font-medium text-foreground">{value}</span>
    </div>
  );
}
